import { render, staticRenderFns } from "./order-modal.vue?vue&type=template&id=4a9a8c42"
import script from "./order-modal.vue?vue&type=script&lang=js"
export * from "./order-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports